import React, { useCallback, useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useSelector, useDispatch } from "react-redux";
import { taxActions } from "../../../redux/actions/guides";
import { SimpleModal, MyInput, MyCheckBox, DialogModal } from "../../../components";
import * as Yup from "yup";
import DeleteIcon from '@material-ui/icons/Delete';
import { Button } from "@material-ui/core";
import { useStateIfMounted } from "use-state-if-mounted";

const defaultValues = { nameTax: "", value: "", mainTax: false };

const validationSchema = Yup.object().shape({
  nameTax: Yup.string().max(60, "Превышено максимальное кол-во символов(60)").required("Обязательное для заполнения поле"),
  value: Yup.number()
    .typeError("Значение должно быть числом")
    .min(0, "Значение должно быть больше 0")
    .max(100, "Значение должно быть меньше 100"),
});

  export const ModalTax = ({ modalShow, onClose, id, refresh = () => { } }) => {
  const dispatch = useDispatch();
  const { item, loadingItem, fetchedItem, deleted, error } = useSelector((state) => state.guides.taxes);

  const [deleteDialog, setDeleteDialog] = useStateIfMounted(false);
  const [isAddMode, setIsAddMode] = useStateIfMounted(true);

  // Основной эффект для определения режима
  useEffect(() => {
    if (!modalShow) return;
    
    const addMode = id == null || isNaN(id);
    setIsAddMode(addMode);
    
    // Если это режим добавления, сбрасываем форму
    if (addMode) {
      reset(defaultValues);
      clearErrors();
    }
  }, [modalShow, id]); // Зависимости: modalShow и id

  // Эффект для загрузки данных при редактировании
  useEffect(() => {
    if (!modalShow || isAddMode || !id) return;

    dispatch(taxActions.getById(id));

    return () => dispatch({ type: "RESET_ITEM_TAXES" });
  }, [modalShow, isAddMode, id]);

  // Эффект для заполнения формы при получении данных
  useEffect(() => {
    if (!fetchedItem || isAddMode || !modalShow) return;

    Object.keys(defaultValues).forEach((field) => setValue(field, item[field]));
  }, [item, fetchedItem, isAddMode, modalShow]);

  const {
    control,
    handleSubmit,
    formState: { errors },
    clearErrors,
    setValue,
    reset,
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: defaultValues,
  });

  const onSubmit = (data) => {
    return isAddMode ? dispatch(taxActions.create(data)) : dispatch(taxActions.update(item.id, data));
  };

  const handleDeleteClick = useCallback((id) => {
    dispatch(taxActions.delete(id));
    setDeleteDialog(false);
  }, [dispatch, setDeleteDialog]);

  // Эффект для обработки успешного удаления
  useEffect(() => {
    if (deleted && modalShow) {
      setDeleteDialog(false);
      closeModalFunc();
      onClose();
      refresh();
      console.log('Налоговая ставка успешно удалена');
    }
  }, [deleted]);

  const closeModalFunc = () => {
    clearErrors();
    reset(defaultValues);
    // Не сбрасываем isAddMode здесь, так как он будет установлен при следующем открытии модалки
  };

  return (
    <div>
      <SimpleModal
        modalTitle={isAddMode ? "Новая налоговая ставка" : "Редактирование"}
        winPermissionName="Общие"
        modalShow={modalShow}
        modalSize="sm"
        fullScreen={false}
        loading={loadingItem}
        isAddMode={isAddMode}
        status={!isAddMode}
        operations={item}
        onSubmit={handleSubmit(onSubmit)}
        onClose={() => {
          onClose();
          closeModalFunc();
        }}
      >
        <form noValidate>
          <MyInput name="nameTax" control={control} label="Наименование" required errors={errors?.nameTax} />
          <MyInput name="value" control={control} label="Значение, %" required errors={errors?.value} />
          <MyCheckBox name="mainTax" control={control} label="Это основной налог" />
          <div>
            <Button
              disabled={isAddMode}
              aria-describedby={id}
              size="small"
              color="primary"
              onClick={() => setDeleteDialog(true)}
              startIcon={<DeleteIcon />}
            >
              Удалить
            </Button>
          </div>
        </form>
      </SimpleModal>
      <DialogModal
        open={deleteDialog}
        onConfirmDialogClose={() => setDeleteDialog(false)}
        onYesClick={() => handleDeleteClick(item?.id)}
        text={`Вы действительно хотите удалить налоговую ставку - ${item?.nameTax}? Это действие невозможно отменить.`}
      />
    </div>
  );
};